import type { Campaign } from "../../../../types/campaign";
import { fromUnixTime } from "date-fns";

export type AnonymousFoojiData = {
  workflow_key: string;
  organization_id: number;
  process_key: string;
  campaign_user: {
    campaign_key: string;
    channel: string;
    identifier: string;
    user_key: string;
  };
  period?: string;
};

type InputType = {
  campaign: Campaign;
  processKey: string;
  fingerprint: string;
  channel: string;
}

export const getCampaignPeriod = (campaign: Campaign): string | undefined => {
  const start = campaign.starts_at;
  const end = campaign.ends_at;

  if (start && end) {
    const startISO = fromUnixTime(start).toISOString();
    const endISO = fromUnixTime(end).toISOString();
    return `${startISO}/${endISO}`;
  }
};

export const buildAnonymousFoojiData = ({
  campaign,
  processKey,
  fingerprint,
  channel
}: InputType): AnonymousFoojiData => {
  const data: AnonymousFoojiData = {
    workflow_key: campaign.campaign_key,
    organization_id: campaign.organization_id,
    process_key: processKey,
    campaign_user: {
      campaign_key: campaign.campaign_key,
      channel,
      identifier: fingerprint,
      user_key: `${campaign.campaign_key}-${channel}-${fingerprint}`
    }
  };

  const period = getCampaignPeriod(campaign);

  if (period) {
    data.period = period;
  }

  return data;
};
